import SelectDOACIndicatie from "../../../../src/client/lta-antistolling/SelectDOACIndicatie.js";
import * as React from 'react';
export default {
  SelectDOACIndicatie,
  React
};